import React from 'react';

function Loading() {
  return (
    <div
      role='status'
      className='h-[50px] w-[50px] animate-spin rounded-full border-4 border-base-300 border-t-secondary ease-in-out'
    >
      <span className='sr-only'>Loading...</span>
    </div>
  );
}

export default Loading;
